import { Grid, Typography } from "@mui/material"
import DetalhesFiltros from "./DetalhesFiltros"
import { useMemo, useState } from "react"
import { verificarDataLabel } from "../../../../../../../helpers/verificarDataLabel"
import { TFiltrosDetalheFechamento } from "../../../../../../../types/api/financeiro/detalhar-fechamentos-conta-corrente"
import TiposPublicos from "./FiltrosModais/TiposPublicos"
import CodigosPublicos from "./FiltrosModais/CodigosPublicos"
import DetalhesPublicos from "./FiltrosModais/DetalhesPublicos"
import PeriodoApuracao from "./FiltrosModais/PeriodoApuracao"
import TitReceberAberto from "./FiltrosModais/TitReceberAberto"
import TitPagarAberto from "./FiltrosModais/TitPagarAberto"
import ChipWithDialogTableSimples from "../../../../../../../components/ChipWithDialogTableSimples"
import NumeroLancamento from "./FiltrosModais/NumeroLancamento"

export default function FiltrosAplicadosFechamento({
    isEdit,
    filtrosParams,
    handleUpdateFiltros
}: FiltrosAplicadosFechamentoProps) {

    const [openFiltros, setOpenFiltros] = useState<TOpenFiltros>({
        tipoPublico: false,
        codigoPublico: false,
        detalhePublico: false,
        periodoApuracao: false,
        titReceberAberto: false,
        titPagarAberto: false,
        numeroLancamento: false
    });

    //Funções manipuladoras
    const handleClickOpenFiltros = (key: keyof TOpenFiltros) => {
        setOpenFiltros(prevState => ({ ...prevState, [key]: !prevState[key] }))
    };
    //

    const titReceberEmissaoLabel = useMemo(() => {
        return verificarDataLabel(filtrosParams.titulo_receber_aberto.periodo_emissao_inicio, filtrosParams.titulo_receber_aberto.periodo_emissao_fim)
    }, [filtrosParams.titulo_receber_aberto.periodo_emissao_inicio, filtrosParams.titulo_receber_aberto.periodo_emissao_fim])

    const titReceberVencimentoLabel = useMemo(() => {
        return verificarDataLabel(filtrosParams.titulo_receber_aberto.periodo_vencimento_inicio, filtrosParams.titulo_receber_aberto.periodo_vencimento_fim)
    }, [filtrosParams.titulo_receber_aberto.periodo_vencimento_inicio, filtrosParams.titulo_receber_aberto.periodo_vencimento_fim])

    const titPagarEmissaoLabel = useMemo(() => {
        return verificarDataLabel(filtrosParams.titulo_pagar_aberto.periodo_emissao_inicio, filtrosParams.titulo_pagar_aberto.periodo_emissao_fim)
    }, [filtrosParams.titulo_pagar_aberto.periodo_emissao_inicio, filtrosParams.titulo_pagar_aberto.periodo_emissao_fim])

    const titPagarVencimentoLabel = useMemo(() => {
        return verificarDataLabel(filtrosParams.titulo_pagar_aberto.periodo_vencimento_inicio, filtrosParams.titulo_pagar_aberto.periodo_vencimento_fim)
    }, [filtrosParams.titulo_pagar_aberto.periodo_vencimento_inicio, filtrosParams.titulo_pagar_aberto.periodo_vencimento_fim])

    const verificarFiltrosReceber = useMemo(() => {
        return titReceberEmissaoLabel === "Todos" && titReceberVencimentoLabel === "Todos" && !filtrosParams.titulo_receber_aberto.funcao
    }, [titReceberEmissaoLabel, titReceberVencimentoLabel, filtrosParams.titulo_receber_aberto.funcao])

    const verificarFiltrosPagar = useMemo(() => {
        return titPagarEmissaoLabel === "Todos" && titPagarVencimentoLabel === "Todos"
    }, [titPagarEmissaoLabel, titPagarVencimentoLabel])

    const codigosPublicos = useMemo(() => {
        const defaultValue = filtrosParams.codigos_publicos
        const value = typeof defaultValue === "object" && "apenas_os_codigos" in defaultValue && defaultValue.apenas_os_codigos.length > 0
            ? `Apenas: ${defaultValue.apenas_os_codigos.join(', ')}`
            : typeof defaultValue === "object" && "exceto_os_codigos" in defaultValue && defaultValue.exceto_os_codigos.length > 0
                ? `Exceto: ${defaultValue.exceto_os_codigos.join(', ')}`
                : "Todos";
        return value
    }, [filtrosParams.codigos_publicos])
    //
    return (
        <>
            <Typography ><b>Filtros aplicados nesse fechamento</b></Typography>
            <Grid container spacing={1} mb={2}>
                <Grid size={{ xs: 6, sm: 4, md: 2 }}>
                    <DetalhesFiltros
                        {...{ isEdit }}
                        gap={1}
                        label="Tipos público"
                        value={filtrosParams.tipos_publicos.join(', ')}
                        action={() => { handleClickOpenFiltros('tipoPublico') }}
                    />
                </Grid>
                <Grid size={{ xs: 6, sm: 4, md: 3 }}>
                    <DetalhesFiltros
                        {...{ isEdit }}
                        gap={1}
                        label="Códigos público"
                        value={codigosPublicos}
                        action={() => { handleClickOpenFiltros('codigoPublico') }}
                    />
                </Grid>
                <Grid size={{ xs: 6, sm: 4, md: 4 }}>
                    <DetalhesFiltros
                        {...{ isEdit }}
                        gap={1}
                        label="Detalhes do público"
                        value={filtrosParams.detalhe_publico}
                        action={() => { handleClickOpenFiltros('detalhePublico') }}
                    />
                </Grid>
                <Grid size={{ xs: 6, sm: 4, md: 3 }}>
                    <DetalhesFiltros
                        {...{ isEdit }}
                        gap={1}
                        label="Período apuração"
                        value={`${verificarDataLabel(filtrosParams.periodo_apuracao.inicio, filtrosParams.periodo_apuracao.fim)}`}
                        action={() => { handleClickOpenFiltros('periodoApuracao') }}
                    />
                </Grid>
                <Grid size={{ xs: 6, sm: 4, md: 5 }}>
                    <DetalhesFiltros
                        {...{ isEdit }}
                        gap={1}
                        label="Títulos a receber em aberto"
                        value={
                            <>
                                {
                                    filtrosParams.titulo_receber_aberto.considera_titulos === "Não" &&
                                    <span>Nenhum</span>
                                }{
                                    (filtrosParams.titulo_receber_aberto.considera_titulos === "Sim" || !filtrosParams.titulo_receber_aberto.considera_titulos) &&
                                    <>
                                        {
                                            verificarFiltrosReceber &&
                                            <span>
                                                Todos
                                            </span>
                                        }
                                        {
                                            !verificarFiltrosReceber &&
                                            <>
                                                <span>
                                                    Emissão: {titReceberEmissaoLabel}
                                                </span>
                                                <br />
                                                <span>
                                                    Vencimento: {titReceberVencimentoLabel}
                                                </span>
                                                <br />
                                                {
                                                    !filtrosParams.titulo_receber_aberto.funcao &&
                                                    <span>
                                                        Função: Todas consideradas
                                                    </span>
                                                }
                                                {
                                                    filtrosParams?.titulo_receber_aberto.funcao &&
                                                    <span>
                                                        Função:  {
                                                            filtrosParams?.titulo_receber_aberto.funcao.length <= 0 ? "-" :
                                                                `${filtrosParams?.titulo_receber_aberto.funcao.slice(0, 3).map(item => item.id).join(', ')} `
                                                        }
                                                        {
                                                            filtrosParams?.titulo_receber_aberto.funcao.length > 3 &&
                                                            <ChipWithDialogTableSimples
                                                                chipCount={`+${filtrosParams?.titulo_receber_aberto.funcao.length - 3}`}
                                                                dialogTitle="Funções"
                                                                headers={[
                                                                    { label: "Id" },
                                                                    { label: "Nome" }
                                                                ]}
                                                                rows={filtrosParams?.titulo_receber_aberto.funcao.map(row => ({
                                                                    columns: [
                                                                        { value: row.id },
                                                                        { value: row.nome }
                                                                    ]
                                                                }))}
                                                                maxHeight={600}
                                                            />
                                                        }
                                                    </span>
                                                }
                                                <br />
                                                {
                                                    !filtrosParams?.titulo_receber_aberto.tipo_documento &&
                                                    <span>
                                                        Tipo documento: Todos considerados
                                                    </span>
                                                }
                                                {
                                                    filtrosParams?.titulo_receber_aberto.tipo_documento &&
                                                    <span>
                                                        Tipo documento:  {
                                                            filtrosParams?.titulo_receber_aberto.tipo_documento.length <= 0 ? "-" :
                                                                `${filtrosParams?.titulo_receber_aberto.tipo_documento.slice(0, 3).map(item => item.id).join(', ')} `
                                                        }
                                                        {
                                                            filtrosParams?.titulo_receber_aberto.tipo_documento.length > 3 &&
                                                            <ChipWithDialogTableSimples
                                                                chipCount={`+${filtrosParams?.titulo_receber_aberto.tipo_documento.length - 3}`}
                                                                dialogTitle="Funções"
                                                                headers={[
                                                                    { label: "Id" },
                                                                    { label: "Nome" }
                                                                ]}
                                                                rows={filtrosParams?.titulo_receber_aberto.tipo_documento.map(row => ({
                                                                    columns: [
                                                                        { value: row.id },
                                                                        { value: row.nome }
                                                                    ]
                                                                }))}
                                                                maxHeight={600}
                                                            />
                                                        }
                                                    </span>
                                                }
                                                <br />
                                                {
                                                    !filtrosParams?.titulo_receber_aberto.situacao &&
                                                    <span>
                                                        Situação: Todas consideradas
                                                    </span>
                                                }
                                                {
                                                    filtrosParams?.titulo_receber_aberto.situacao &&
                                                    <span>
                                                        Situação:  {
                                                            filtrosParams?.titulo_receber_aberto.situacao.length <= 0 ? "-" :
                                                                `${filtrosParams?.titulo_receber_aberto.situacao.slice(0, 3).map(item => item.id).join(', ')} `
                                                        }
                                                        {
                                                            filtrosParams?.titulo_receber_aberto.situacao.length > 3 &&
                                                            <ChipWithDialogTableSimples
                                                                chipCount={`+${filtrosParams?.titulo_receber_aberto.situacao.length - 3}`}
                                                                dialogTitle="Funções"
                                                                headers={[
                                                                    { label: "Id" },
                                                                    { label: "Nome" }
                                                                ]}
                                                                rows={filtrosParams?.titulo_receber_aberto.situacao.map(row => ({
                                                                    columns: [
                                                                        { value: row.id },
                                                                        { value: row.nome }
                                                                    ]
                                                                }))}
                                                                maxHeight={600}
                                                            />
                                                        }
                                                    </span>
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </>
                        }
                        action={() => { handleClickOpenFiltros('titReceberAberto') }}
                    />
                </Grid>
                <Grid size={{ xs: 6, sm: 4, md: 4 }}>
                    <DetalhesFiltros
                        {...{ isEdit }}
                        gap={1}
                        label="Títulos a pagar em aberto"
                        value={
                            <>
                                {
                                    filtrosParams.titulo_pagar_aberto.considera_titulos === "Não" &&
                                    <span>Nenhum</span>
                                }
                                {
                                    (filtrosParams.titulo_pagar_aberto.considera_titulos === "Sim" || !filtrosParams.titulo_pagar_aberto.considera_titulos) &&
                                    <>
                                        {
                                            verificarFiltrosPagar &&
                                            <span>
                                                Todos
                                            </span>
                                        }
                                        {
                                            !verificarFiltrosPagar &&
                                            <>
                                                <span>
                                                    Emissão: {titPagarEmissaoLabel}
                                                </span>
                                                <br />
                                                <span>
                                                    Vencimento: {titPagarVencimentoLabel}
                                                </span>
                                            </>
                                        }
                                    </>
                                }
                            </>
                        }
                        action={() => { handleClickOpenFiltros('titPagarAberto') }}
                    />
                </Grid>
                <Grid size={{ xs: 6, sm: 3, md: 3 }}>
                    <DetalhesFiltros
                        {...{ isEdit }}
                        gap={1}
                        label="Número do lançamento"
                        value={filtrosParams.numero_lancamento && filtrosParams.numero_lancamento.trim() !== "" ? filtrosParams.numero_lancamento : "Nenhum"}
                        action={() => { handleClickOpenFiltros('numeroLancamento') }}
                    />
                </Grid>
            </Grid>
            {
                openFiltros.tipoPublico &&
                <TiposPublicos
                    open={openFiltros.tipoPublico}
                    defaultValue={filtrosParams.tipos_publicos}
                    onSubmitFiltros={(value: any) => handleUpdateFiltros('tipos_publicos', value)}
                    onClose={() => handleClickOpenFiltros('tipoPublico')}
                />
            }
            {
                openFiltros.codigoPublico &&
                <CodigosPublicos
                    open={openFiltros.codigoPublico}
                    defaultValue={filtrosParams.codigos_publicos}
                    onSubmitFiltros={(value: any) => handleUpdateFiltros('codigos_publicos', value)}
                    onClose={() => handleClickOpenFiltros('codigoPublico')}
                />
            }
            {
                openFiltros.detalhePublico &&
                <DetalhesPublicos
                    open={openFiltros.detalhePublico}
                    defaultValue={filtrosParams.detalhe_publico}
                    onSubmitFiltros={(value: any) => handleUpdateFiltros('detalhe_publico', value)}
                    onClose={() => handleClickOpenFiltros('detalhePublico')}
                />
            }
            {
                openFiltros.periodoApuracao &&
                <PeriodoApuracao
                    open={openFiltros.periodoApuracao}
                    defaultValue={filtrosParams.periodo_apuracao}
                    onSubmitFiltros={(value: any) => handleUpdateFiltros('periodo_apuracao', value)}
                    onClose={() => handleClickOpenFiltros('periodoApuracao')}
                />
            }
            {
                openFiltros.titReceberAberto &&
                <TitReceberAberto
                    open={openFiltros.titReceberAberto}
                    defaultValue={filtrosParams.titulo_receber_aberto}
                    onSubmitFiltros={(value: any) => handleUpdateFiltros('titulo_receber_aberto', value)}
                    onClose={() => handleClickOpenFiltros('titReceberAberto')}
                />
            }
            {
                openFiltros.titPagarAberto &&
                <TitPagarAberto
                    open={openFiltros.titPagarAberto}
                    defaultValue={filtrosParams.titulo_pagar_aberto}
                    onSubmitFiltros={(value: any) => handleUpdateFiltros('titulo_pagar_aberto', value)}
                    onClose={() => handleClickOpenFiltros('titPagarAberto')}
                />
            }
            {
                openFiltros.numeroLancamento &&
                <NumeroLancamento
                    open={openFiltros.numeroLancamento}
                    defaultValue={filtrosParams.numero_lancamento}
                    onSubmitFiltros={(value: any) => handleUpdateFiltros('numero_lancamento', value)}
                    onClose={() => handleClickOpenFiltros('numeroLancamento')}
                />
            }
        </>
    )
}

interface FiltrosAplicadosFechamentoProps {
    isEdit: boolean
    filtrosParams: TFiltrosDetalheFechamento
    handleUpdateFiltros: (key: keyof TFiltrosDetalheFechamento, value: any) => void
}

type TOpenFiltros = {
    tipoPublico: boolean,
    codigoPublico: boolean,
    detalhePublico: boolean,
    periodoApuracao: boolean,
    titReceberAberto: boolean,
    titPagarAberto: boolean
    numeroLancamento: boolean
}
